import { useDataSubmit, useDataValue } from 'Simple/Data'
import { timeAgoShort } from 'Data/format.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let submitOpenTab = useDataSubmit({
    context: 'inbox_actions',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'message',
    path: 'id',
    viewPath: props.viewPath,
  })

  let task_id = useDataValue({
    context: 'message',
    path: 'resource.id',
    viewPath: props.viewPath,
  })

  let resource = useDataValue({
    context: 'message',
    path: 'resource.resource_table',
    viewPath: props.viewPath,
  })

  return async function onClick(value) {
    await submit({ type: 'mark-as-read', value: { id } })
    if (resource === 'tasks') {
      await submitOpenTab({ value: { task_id } })
    }
  }
}

export function timeAgo(date, suffix) {
  return `${timeAgoShort(date)} ${suffix}`
}
